
function setStates(ids) {
    for (var i = 0; i < ids.length; i++) {
        $('#menu_' + ids[i]).removeClass('active');
    }

    for (var i = 0; i < ids.length; i++) {
        if (isInViewport(ids[i])) {
            $('#menu_' + ids[i]).addClass('active');
            break;
        }
    }
}

function isInViewport(id) {
    var el = document.getElementById(id);
    const rect = el.getBoundingClientRect();
    let real = rect.top + rect.height - 300;
    return real > 0;
}

function okScrollTo(id, offset) {
    if (!offset) {
        offset = 100;
    }

    var element = document.getElementById(id);
    var headerOffset = offset;
    var elementPosition = element.getBoundingClientRect().top;
    var offsetPosition = elementPosition + window.pageYOffset - headerOffset;

    window.scrollTo({
        top: offsetPosition,
        behavior: "smooth"
    });
}


function navLeft() {
    let menuEl = document.getElementById('navbar-menu');
    var newPosition = menuEl.scrollLeft - 10;

    if (newPosition < 0) {
        newPosition = 0;
    }

    menuEl.scroll({ left: newPosition });
}

function navRight() {
    let menuEl = document.getElementById('navbar-menu');
    var newPosition = menuEl.scrollLeft + 10;

    if (newPosition > menuEl.offsetWidth) {
        newPosition = menuEl.offsetWidth;
    }

    menuEl.scroll({ left: newPosition });
}

function closeMenuOverlay() {
    var collapseEl = document.getElementById('navbar-menu');
    var bsCollapse = new bootstrap.Collapse(collapseEl);
    bsCollapse.hide();
    document.getElementById('menu-overlay').classList.add('d-none');
}

function toggleMenuOverlay() {
    let button = document.getElementById('mainmenu-button');
    let isOpen = button.getAttribute('aria-expanded');

    if (isOpen == 'true') {
        document.getElementById('menu-overlay').classList.remove('d-none');
    }
    else {
        document.getElementById('menu-overlay').classList.add('d-none');
    }
}